import { Image } from "antd";
import logo from "../../assets/images/Logo_250.png";

export const Logo: React.FC = () => (
  <div className="text-center">
    <Image src={logo} width={"50%"} preview={false} />
  </div>
);
